import { all, takeLatest, throttle } from 'redux-saga/effects'

function * handleHover (action) {
  if (action.payload < 0) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    event_action: 'hover',
    event_label: `HOVER_OVER:${action.payload}`
  })
}

function * watchSelector () {
  yield takeLatest(
    action => /^SELECTOR/.test(action.type),
    action => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'Interactions',
        event_action: 'click',
        event_label: `${action.type}:${action.payload}`
      })
    }
  )
}

function * watchHover () {
  yield throttle(1000, 'MAP/ACTIVE_MUNICIPALITY', handleHover)
}

export default function * analyticsWatcher () {
  yield all([watchSelector(), watchHover()])
}
